import { createAPI } from '../../composable/useAPI';

/**
 * useProductionStatAPI — 트랙 9-3b 생산통계 페이지 전용 hook.
 * 단건 CRUD 가 아닌 통계 집계 endpoint 만 노출한다.
 */
export const useProductionStatAPI = () => {
  const api = createAPI();

  const request = {
    summary: async (params) => {
      return await api
        .get('/api/v2/progress/summary', { params })
        .then((res) => res.data.data)
        .catch((err) => {
          console.error(err);
          return null;
        });
    },
  };

  return { ...request };
};
